import React from 'react'

const StepQuestion = ({ question, preheader }) => {
    return (
        <legend className="font-grotesk-medium text-3xl leading-snug lg:text-[32px]">
            <span className="block text-3xl text-vivid_raspberry lg:text-[32px] lg:leading-[38px]">
                {preheader}
            </span>
            <span className='text-3xl font-grotesk-bold'>{question}</span>
        </legend>
    )
}

export default StepQuestion
